import type * as lazyIndex from "./lazyIndex";
import { LazyBootModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(() => import(/* webpackChunkName: "AdditionalSuggestedPendingAccounts" */ "./lazyIndex"), { name: "AdditionalSuggestedPendingAccounts" });

export const lazyDiscoverAdditionalSuggestedPendingAccounts: LazyAction<typeof lazyIndex.startAdditionalSuggestedPendingAccountDiscovery, typeof lazyModule> = new LazyAction(lazyModule, m => m.startAdditionalSuggestedPendingAccountDiscovery);
